import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserAuthorizationService, IFeaturesService, IOpsViewerMessagesService } from '../services/services';
import { Features } from '../models/models';
import { IUserManagerService } from '../services/iUserManager.service';

@Injectable()
export class CanEditGuard  {

    constructor(
        private router: Router,
        private featureService: IFeaturesService,
        private _userManagerService: IUserManagerService,
        private _userAuthorizationService: UserAuthorizationService,
        private messageService: IOpsViewerMessagesService,
        ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable<boolean>(observer => {
            this.featureService.isFeatureEnabled(Features.CompanyAdministration).subscribe(
                isCompanyAdministrationEnabled => {
                    this._userManagerService.getCurrentUser().subscribe(user => {
                        const result = isCompanyAdministrationEnabled
                            ? this._userAuthorizationService.isUserAnyRoleEditorOrAdmin(user, false)
                            : this._userAuthorizationService.isUserAnyRoleEditorOrAdmin(user, true);
                        if (!result) {
                            this.messageService.warnMessage('User does not have permission to this feature.', '');
                        }
                        observer.next(result);
                        observer.complete();
                    });
                        }
                    );
                }
            );
     
    }
}
